const API_BASE = '';

async function fetchJson(url, options = {}) {
  const response = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  });

  const data = await response.json().catch(() => ({ message: 'Request failed' }));

  if (!response.ok) {
    const error = new Error(data.message || 'Request failed');
    error.requiresVerification = data.requiresVerification;
    throw error;
  }

  return data;
}

const api = {
  // Auth
  getCurrentUser: () => fetchJson(`${API_BASE}/auth/me`),

  register: (email, password, name) =>
    fetchJson(`${API_BASE}/auth/register`, {
      method: 'POST',
      body: JSON.stringify({ email, password, name })
    }),

  verifyEmail: (email, code) =>
    fetchJson(`${API_BASE}/auth/verify`, {
      method: 'POST',
      body: JSON.stringify({ email, code })
    }),

  resendCode: (email) =>
    fetchJson(`${API_BASE}/auth/resend-code`, {
      method: 'POST',
      body: JSON.stringify({ email })
    }),

  login: (email, password) =>
    fetchJson(`${API_BASE}/auth/login`, {
      method: 'POST',
      body: JSON.stringify({ email, password })
    }),

  adminLogin: (username, password) =>
    fetchJson(`${API_BASE}/auth/admin-login`, {
      method: 'POST',
      body: JSON.stringify({ username, password })
    }),

  logout: () => fetchJson(`${API_BASE}/auth/logout`),

  // Users
  getAllUsers: () => fetchJson(`${API_BASE}/api/users`),

  getUser: (id) => fetchJson(`${API_BASE}/api/users/${id}`),

  // Groups
  getMyGroups: () => fetchJson(`${API_BASE}/api/groups`),

  createGroup: (name) =>
    fetchJson(`${API_BASE}/api/groups`, {
      method: 'POST',
      body: JSON.stringify({ name })
    }),

  joinGroup: (inviteCode) =>
    fetchJson(`${API_BASE}/api/groups/join`, {
      method: 'POST',
      body: JSON.stringify({ inviteCode })
    }),

  getGroup: (id) => fetchJson(`${API_BASE}/api/groups/${id}`),

  getGroupMembers: (groupId) =>
    fetchJson(`${API_BASE}/api/groups/${groupId}/members`),

  deleteGroup: (groupId) =>
    fetchJson(`${API_BASE}/api/groups/${groupId}`, {
      method: 'DELETE'
    }),

  // Predictions
  getNominees: () => fetchJson(`${API_BASE}/api/predictions/nominees`),

  getCategories: () => fetchJson(`${API_BASE}/api/predictions/categories`),

  getDeadline: () => fetchJson(`${API_BASE}/api/predictions/deadline`),

  getMyPredictions: (groupId) =>
    fetchJson(`${API_BASE}/api/predictions/group/${groupId}`),

  savePredictions: (groupId, predictions) =>
    fetchJson(`${API_BASE}/api/predictions/group/${groupId}`, {
      method: 'POST',
      body: JSON.stringify({ predictions })
    }),

  getUserPredictions: (userId, groupId) =>
    fetchJson(`${API_BASE}/api/predictions/user/${userId}/group/${groupId}`),

  // Admin
  getAdminCategories: () => fetchJson(`${API_BASE}/api/admin/categories`),

  getWinners: () => fetchJson(`${API_BASE}/api/admin/winners`),

  setWinner: (category, winner) =>
    fetchJson(`${API_BASE}/api/admin/winners`, {
      method: 'POST',
      body: JSON.stringify({ category, winner })
    }),

  deleteWinner: (category) =>
    fetchJson(`${API_BASE}/api/admin/winners/${encodeURIComponent(category)}`, {
      method: 'DELETE'
    }),

  calculateScores: () =>
    fetchJson(`${API_BASE}/api/admin/calculate-scores`, {
      method: 'POST'
    }),

  getOverallWinner: () => fetchJson(`${API_BASE}/api/admin/overall-winner`),

  getVapidPublicKey: () => fetchJson(`${API_BASE}/api/admin/vapid-public-key`),

  subscribeToPush: (subscription) =>
    fetchJson(`${API_BASE}/api/admin/push-subscribe`, {
      method: 'POST',
      body: JSON.stringify({ subscription })
    }),

  deleteUser: (userId, password) =>
    fetchJson(`${API_BASE}/api/admin/users/${userId}`, {
      method: 'DELETE',
      body: JSON.stringify({ password })
    }),

  // Legal
  getTerms: () => fetchJson(`${API_BASE}/api/legal/terms`),

  getPrivacy: () => fetchJson(`${API_BASE}/api/legal/privacy`),

  deleteMyData: () =>
    fetchJson(`${API_BASE}/api/legal/unsubscribe`, {
      method: 'POST'
    }),

  getMyData: () => fetchJson(`${API_BASE}/api/legal/my-data`)
};

export default api;
